const KEY = "itz_src";
const host = () => { try { return document.referrer ? new URL(document.referrer).hostname : ""; } catch { return ""; } };

function detect() {
  const p = new URLSearchParams(window.location.search);
  const utm = (p.get("utm_source") || "").toLowerCase();
  const ua = navigator.userAgent || "";
  const ref = host();
  if (["instagram", "ig"].includes(utm) || /Instagram/.test(ua) || /(^|\.)instagram\.com$/i.test(ref) || p.has("igshid")) return "instagram";
  if (utm === "tiktok" || p.has("ttclid") || /musical_ly|BytedanceWebview|TikTok/i.test(ua) || /(^|\.)tiktok\.com$/i.test(ref)) return "tiktok";
  if (["facebook", "fb"].includes(utm) || p.has("fbclid") || /FBAN|FBAV/.test(ua) || /(^|\.)(facebook\.com|fb\.com|fb\.me)$/i.test(ref)) return "facebook";
  return null;
}

export function detectAdSource() {
  const src = detect();
  if (src) localStorage.setItem(KEY, src);
}

export const getAdSource = () => localStorage.getItem(KEY) || null;
export const clearAdSource = () => localStorage.removeItem(KEY);
